export default __webpack_public_path__ + "static/hero_desktop-dbb98ff867a64bcf4124e5af668d71ab.webp";